var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreativeAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3287 3.10872L27.0603 7.81652C28.0797 8.36643 28.0797 9.9357 27.0603 10.4856L18.3287 15.1934C17.5508 15.6092 16.6388 15.6092 15.8608 15.1934L7.12926 10.4856C6.10991 9.9357 6.10991 8.36643 7.12926 7.81652L15.8608 3.10872C16.6388 2.69293 17.5508 2.69293 18.3287 3.10872Z",
    stroke: "#292D32",
    strokeWidth: 1.71576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84204 13.653L13.9566 17.717C14.9626 18.2267 15.6064 19.2595 15.6064 20.3861V28.0581C15.6064 29.1713 14.4395 29.8822 13.4469 29.3859L5.33236 25.3219C4.32642 24.8123 3.68262 23.7795 3.68262 22.6528V14.9809C3.68262 13.8676 4.84951 13.1568 5.84204 13.653Z",
    stroke: "#292D32",
    strokeWidth: 1.71576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3483 13.653L20.2337 17.717C19.2278 18.2267 18.584 19.2595 18.584 20.3861V28.0581C18.584 29.1713 19.7509 29.8822 20.7434 29.3859L28.858 25.3219C29.8639 24.8123 30.5077 23.7795 30.5077 22.6528V14.9809C30.5077 13.8676 29.3408 13.1568 28.3483 13.653Z",
    stroke: "#292D32",
    strokeWidth: 1.71576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeAi);
export default __webpack_public_path__ + "static/media/CreativeAI.6675c16769eaa57ba91c9511cc903dbd.svg";
export { ForwardRef as ReactComponent };